import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import PlatformIcon from '../common/PlatformIcon';
import RaisedCenterAction from '../common/RaisedCenterAction';

export interface BottomTabItem {
  key: string;
  label: string;
  icon: string;
  badge?: number | string;
  labelKey?: string;
}

export interface BottomTabBarProps {
  items: BottomTabItem[];
  activeIndex: number;
  onPress: (index: number, key: string) => void;
  showRaisedCenter?: boolean;
  onCenterPress?: () => void;
}

const BottomTabBar: React.FC<BottomTabBarProps> = ({ items, activeIndex, onPress, showRaisedCenter = true, onCenterPress }) => {
  const count = items.length;
  const centerIndex = Math.floor(count / 2);

  return (
    <View style={styles.container}>
      {items.map((it, idx) => {
      const isActive = idx === activeIndex;
        const color = isActive ? '#4A86F7' : '#666666';
        const showCenter = showRaisedCenter && idx === centerIndex;
  const iconSize = 24;
        return (
          <TouchableOpacity key={it.key} style={styles.item} onPress={() => onPress(idx, it.key)} activeOpacity={0.8}>
            <View style={styles.itemInner}>
              <View style={styles.iconWrap}>
                {showCenter ? (
                  <RaisedCenterAction onPress={onCenterPress} />
                ) : (
                  <PlatformIcon name={it.icon} size={iconSize} color={color} />
                )}
                {it.badge ? (
                  <View style={styles.badge}>
                    <Text style={styles.badgeText}>{String(it.badge)}</Text>
                  </View>
                ) : null}
              </View>
              {it.label ? <Text style={[styles.label, { color }]} numberOfLines={1}>{it.label}</Text> : null}
            </View>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    height: 50,
    alignItems: 'center',
    justifyContent: 'space-around',
    backgroundColor: 'transparent',
    paddingBottom: Platform.OS === 'web' ? 0 : 6,
    paddingTop: 2,
  },
  item: {
    flex: 1,
    alignItems: 'stretch',
    justifyContent: 'flex-end',
  },
  itemInner: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
  },
  iconWrap: {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    marginTop: 2,
    fontSize: 12,
    fontWeight: '600',
  },
  badge: {
    position: 'absolute',
    top: -4,
    right: -6,
    backgroundColor: '#FF4757',
    borderRadius: 10,
    minWidth: 18,
    height: 18,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
    borderWidth: 2,
    borderColor: '#FFFFFF',
  },
  badgeText: {
    color: '#FFFFFF',
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default BottomTabBar;
